import { CardVariant } from "../../../models/CardVariant";
import { opusStringToId } from "../../../models/Opus";
import { IFilterCommand } from "../IFilterCommand";

const UNPLAYABLE_OPUS: number[] = [
    opusStringToId["A"],
    opusStringToId["B"],
    opusStringToId["C"]
];

export class PlayableFilter<TItem extends CardVariant> implements IFilterCommand<TItem, void> {
    isMatch(item: TItem, filters: void): boolean {
        return !UNPLAYABLE_OPUS.includes(item.opus);
    }
}